import { useEffect, useMemo, useState } from 'react';
import { supabase } from '../lib/supabaseClient';
import ProductCard from './ProductCard';
import ProductModal from './ProductModal';
import heroImage from '../assets/hero-mug.png';
import logoInkova from '../assets/logo-inkova.png';

export default function Catalog() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState('todos');
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadData() {
      setLoading(true);

      const { data: productsData, error: productsError } = await supabase
        .from('products')
        .select('*')
        .eq('active', true)
        .order('created_at', { ascending: false });

      const { data: categoriesData, error: categoriesError } = await supabase
        .from('categories')
        .select('*')
        .eq('active', true)
        .order('sort_order', { ascending: true });

      if (productsError) console.error(productsError);
      if (categoriesError) console.error(categoriesError);

      setProducts(productsData || []);
      setCategories(categoriesData || []);
      setLoading(false);
    }

    loadData();
  }, []);

  const filtered = useMemo(() => {
    if (category === 'todos') return products;

    return products.filter((item) => {
      return item.category_id === category || item.category === category;
    });
  }, [products, category]);

  return (
    <main>
      <nav className="navbar">
        <a href="/" className="brand">
  <img
    src={logoInkova}
    alt="INKOVA STUDIO"
    className="brandLogo"
  />
</a>

        <div className="navLinks">
          <a href="/">Inicio</a>
          <a href="#catalogo">Catálogo</a>
          <a
            href="https://wa.me/34692593183"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contacto
          </a>
        </div>
      </nav>

      <section className="hero">
        <div className="heroText">
          <p className="eyebrow">INKOVA STUDIO</p>

          <h1>
            Regalos personalizados
            <br />
            que dejan huella
          </h1>

          <span className="heroLine"></span>

          <p>
            Diseñamos detalles únicos para sorprender, regalar y recordar.
          </p>
        </div>

        <div className="heroVisual">
          <img
            src={heroImage}
            alt="Taza personalizada INKOVA STUDIO"
          />
        </div>
      </section>

      <section className="filters" id="catalogo">
        <button
          className={category === 'todos' ? 'active' : ''}
          onClick={() => setCategory('todos')}
        >
          Todos
        </button>

        {categories.map((item) => (
          <button
            key={item.id}
            className={category === item.id ? 'active' : ''}
            onClick={() => setCategory(item.id)}
          >
            {item.name}
          </button>
        ))}
      </section>

      <section className="catalogGrid">
        {loading && <p>Cargando productos...</p>}

        {!loading && filtered.length === 0 && (
          <p>No hay productos disponibles en esta categoría todavía.</p>
        )}

        {filtered.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            onOpen={setSelected}
          />
        ))}
      </section>

      <a
        className="whatsappFloat"
        href="https://wa.me/34692593183"
        target="_blank"
        rel="noopener noreferrer"
      >
        <span>💬</span>
        <div>
          <strong>¿Te ayudamos?</strong>
          <small>Escríbenos por WhatsApp</small>
        </div>
      </a>
      
      <section className="socialSection">
  <h3>Encuéntranos en redes</h3>

  <div className="socialLinks">
    <a
      href="https://instagram.com/TU_USUARIO"
      target="_blank"
      rel="noopener noreferrer"
    >
      Instagram
    </a>

    <a
      href="https://facebook.com/TU_USUARIO"
      target="_blank"
      rel="noopener noreferrer"
    >
      Facebook
    </a>

    <a
      href="https://tiktok.com/@TU_USUARIO"
      target="_blank"
      rel="noopener noreferrer"
    >
      TikTok
    </a>
  </div>
</section>

      <footer className="footer">
  <p>© {new Date().getFullYear()} INKOVA STUDIO</p>
  <p>Diseño & Personalización</p>
</footer>

      {selected && (
        <ProductModal
          product={selected}
          onClose={() => setSelected(null)}
        />
      )}
    </main>
  );
}